import styled from 'styled-components';

import { DEFAULT_COLORS } from 'constants/colors';
import { SPACING } from 'constants/spacing';

export const AssessmentToolStyled = styled.div`
    display: flex;
    position: relative;
`;

export const SideBarStyled = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 100;
    background-color: ${DEFAULT_COLORS.WHITE};
    padding: 5.75rem 2.375rem 2.375rem 2.375rem;
    width: 15.4375rem;
`;

export const ContentStyled = styled.div`
    flex: 1 1 auto;
    position: relative;
    padding: 0 0.8125rem ${SPACING.XL} 17.625rem;
`;

export const LandingViewContainer = styled.div`
    padding: ${SPACING.XL} 0.8125rem ${SPACING.XL} 0.8125rem;
`;

export const WizardFitnessStep = styled.div`
    position: relative;
    &::before {
        content: '';
        display: block;
        height: 100%;
        width: 0.313rem;
        position: absolute;
        right: calc(0.6785rem - 0.1565rem);
        top: 0;
        background-color: ${DEFAULT_COLORS.LIGHT};
        z-index: 1;
    }
    &:last-of-type,
    &#lastStep {
        &::before {
            display: none;
        }
    }
`;

export const BoxActionsStyled = styled.div`
    display: flex;
    justify-content: space-between;

    ${({ theme }) => theme.media.down('md')`
        height: 50px;
        align-items: center;
    `}
`;

export const MobileAssessmentToolStyled = styled.div`
    display: flex;
    flex-direction: column;
    margin: 1rem 1rem 0.25rem 1rem;
`;

export const MobileAssessmentToolContentStyled = styled.div`
    height: ${({ height }) => height};
`;
